import { FormHeader, FormHeaderActions } from './FormHeader';
import { AritoFormV2 } from '@/components/custom/erp';
import { useFormDialog } from './hooks/useFormDialog';
import type { FormDialogProps } from './types';
import { FormTabs } from './FormTabs';
import BottomBar from './BottomBar';

export default function FormDialog(props: FormDialogProps) {
  const dialog = useFormDialog(props);

  return (
    <AritoFormV2
      mode={dialog.formMode}
      title={dialog.title}
      subTitle='Hóa đơn bán dịch vụ'
      schema={dialog.schema}
      initialData={dialog.initialValues}
      onSubmit={dialog.submit}
      onClose={dialog.onClose}
      headerFields={FormHeader(dialog)}
      headerTabActions={<FormHeaderActions dialog={dialog} />}
      tabs={FormTabs(dialog)}
      bottomBar={<BottomBar calculateTotals={dialog.totals} ty_gia={dialog.formState.state.ty_gia} />}
    />
  );
}
